import styled from "@emotion/styled";
import { Container, Link } from "@mui/material";

const MenuContainer = styled.div`
  width: 100%;
  z-index: 9999;
  transition: all linear 0.3s;
  position: ${(props) => (props.isSticky == "sticky" ? "fixed" : "absolute")};
  background-color: ${(props) => (props.isSticky == "sticky" ? "black" : "")};
  padding: ${(props) => (props.isSticky == "sticky" ? "" : "15px 0")};
  box-shadow: ${(props) =>
    props.isSticky == "sticky" ? "0px 3px 7px rgba(0, 0, 0, 0.51)" : ""};
  img {
    width: ${(props) => (props.isSticky == "80px !important" ? "" : "")};
  }
`;
const DesktopMainMenu = styled(Container)`
  /* padding: 12px 3rem !important; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  display: none;
  
  @media (max-width: 899px) {
  }
`;
const MobileMainMenu = styled.div`

  /* background-color: #fff; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;

  @media (min-width: 900px) {
    /* display: none; */
  }
`;
const SiteLogo = styled.img`
  max-width: 100%;
  height: auto;
`;
const MenuLink = styled(Link)`
  display: block;
  align-items: center !important;
  font-size: max(35px, 40px);
  font-family: "Lucida-Regular";
  font-weight: bolder;
  color: #fff;
  padding: 15px 0;
  /* color: #000; */
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  transition-duration: 0.5s;
  &:nth-child(5) {
    cursor: pointer;
    color: #f4f4f4;
    background-image: url("/images/telegrambg.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom;
    padding: 10px 20px 10px 20px;
    font-family: "Lucida-Regular";
    font-size: max(40px, 45px);
    &:hover {
      /* color: #000; */
      /* opacity: 1; */
    }
    @media screen and (max-width: 899px) {
      font-size: 22px;
      color: #fff;
      background-image: unset;
    }
  }
  
  &:hover,
  &:active,
  &:focus {
    opacity: 0.8;
    /* color: #fff; */
    transition-duration: 0.5s;
  }
  @media (max-width: 899px) {
    display: block;
    border-bottom: 1px solid #1a1a1a;
    text-align: left;
    font-size: 22px;
    background-image: unset;
    padding: 10px 20px 10px 20px;
  }
  &:nth-child(6) {
    padding: 0px;
    border-width: 0px;
  }
`;

export { MenuContainer, DesktopMainMenu, MobileMainMenu, MenuLink, SiteLogo };
